import styled from 'styled-components';

import LogCarrierNotes from './component';

export default styled(LogCarrierNotes)`
  .log-carrier-notes {
    display: flex;

    &__button {
      span svg {
        fill: var(--grey500);
      }
    }

    &__tooltip-container {
      background-color: var(--white);
      border-radius: 8px;
      box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
      opacity: 1;
    }

    &__tooltip {
      display: flex;
      min-width: 400px;
      max-height: 280px;
      overflow-y: scroll;
      padding: 1rem 0;
    }

    &__list {
      list-style-type: none;
      margin: 0;
      padding: 0;
      width: 100%;
    }

    &__content {
      font-size: 12px;
      line-height: 1.33;
      margin: 0;
      padding-bottom: 0.5rem;
      text-align: left;
    }

    &__title {
      color: var(--grey900);
      font-weight: 500;
      text-transform: capitalize;
    }

    &__text {
      color: var(--grey700);
      text-transform: capitalize;
    }

    &__date {
      color: var(--grey500);
    }

    &__item {
      border-bottom: 1px solid var(--grey300);
      display: flex;
      flex-direction: column;
      margin-bottom: 1rem;
    }
  }
`;
